import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {searchSite} from '../../api/search';

const SECTION_LABELS = {
    ml: 'Machine Learning',
    dc: 'Distributed Computing',
    llm: 'Large Language Models',
};

const SECTION_TAG_CLASSES = {
    ml: 'tag-blue',
    dc: 'tag-purple',
    llm: 'tag-green',
};

const SearchResults = () => {
    const [searchParams] = useSearchParams();
    const query = (searchParams.get('q') || '').trim();
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!query) {
            setResults([]);
            return;
        }

        const controller = new AbortController();
        setLoading(true);
        setError(false);

        searchSite(query, {signal: controller.signal})
            .then(setResults)
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    setError(true);
                }
            })
            .finally(() => setLoading(false));

        return () => controller.abort();
    }, [query]);

    return (
        <div className="container py-5">
            <h1 className="text-2xl font-semibold leading-tight text-blue-800 mb-4">
                {query ? `Search results for "${query}"` : 'Search'}
            </h1>

            {loading && <div className="text-gray-400">Searching...</div>}
            {error && <div className="text-red-600">Something went wrong running that search.</div>}
            {!loading && !error && query && results.length === 0 &&
                <div className="text-gray-400">No results found.</div>}

            <ul className="space-y-4">
                {results.map((result) => (
                    <li key={result.slug}
                        className="rounded-lg bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 p-4 shadow-sm">
                        <span className={`tag js-tag-group-entry ${SECTION_TAG_CLASSES[result.section] || 'tag-blue'} mb-2`}>
                            <span>{SECTION_LABELS[result.section] || result.section}</span>
                        </span>
                        <a href={result.path + result.slug}
                           className="block text-lg text-blue-600 font-normal hover:text-red-700">
                            {result.title}
                        </a>
                        <p className="text-sm text-gray-600 mt-1">{result.snippet}...</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SearchResults;
